import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from '../../../../../shared/components/CatalogueRowActions';
import type { CatalogueRowHandlers } from '../../../components/CataloguePanel';
import type { ContainerType } from '../../../reference-data.api';

export function buildContainerTypeColumns({ onEdit, onDeactivate, onReactivate }: CatalogueRowHandlers<ContainerType>): TableColumnsType<ContainerType> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    {
      title: 'Needs',
      key: 'needs',
      render: (_, row) => (
        <span className="flex gap-1">
          {row.needsReeferPower && <Tag>Reefer power</Tag>}
          {row.needsSkeletalOrFlatRack && <Tag>Skeletal or flat rack</Tag>}
        </span>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
